module.exports = __webpack_public_path__ + "img/infibo-how-to-subscribe-ru-1.f253098f.png";